import { RouterModule, Routes } from "@angular/router";
import { DocumentoTipoEditComponent } from "./components/admin/documento-tipo-edit/documento-tipo-edit.component";
import { DocumentoTipoListComponent } from "./components/admin/documento-tipo-list/documento-tipo-list.component";
import { EquipeResponsabilidadeEditComponent } from "./components/admin/equipe-responsabilidade-edit/equipe-responsabilidade-edit.component";
import { EquipeResponsabilidadeListComponent } from "./components/admin/equipe-responsabilidade-list/equipe-responsabilidade-list.component";
import { ExportarListComponent } from "./components/admin/exportar-list/exportar-list.component";
import { LinkEvidenciaEditComponent } from "./components/admin/link-evidencia-edit/link-evidencia-edit.component";
import { LinkEvidenciaListComponent } from "./components/admin/link-evidencia-list/link-evidencia-list.component";
import { LinkLegislacaoEditComponent } from "./components/admin/link-legislacao-edit/link-legislacao-edit.component";
import { LinkLegislacaoListComponent } from "./components/admin/link-legislacao-list/link-legislacao-list.component";
import { ProcessoQuestaoEditComponent } from "./components/admin/processo-questao-edit/processo-questao-edit.component";
import { ProcessoQuestaoListComponent } from "./components/admin/processo-questao-list/processo-questao-list.component";
import { ProcessoStatusEditComponent } from "./components/admin/processo-status-edit/processo-status-edit.component";
import { ProcessoStatusListComponent } from "./components/admin/processo-status-list/processo-status-list.component";
import { ProdutoDocumentoEditComponent } from "./components/admin/produto-documento-edit/produto-documento-edit.component";
import { ProdutoDocumentoListComponent } from "./components/admin/produto-documento-list/produto-documento-list.component";
import { ProdutoEtapaModalidadeEditComponent } from "./components/admin/produto-etapa-modalidade-edit/produto-etapa-modalidade-edit.component";
import { ProdutoEtapaModalidadeListComponent } from "./components/admin/produto-etapa-modalidade-list/produto-etapa-modalidade-list.component";
import { ProdutoModalidadeEditComponent } from "./components/admin/produto-modalidade-edit/produto-modalidade-edit.component";
import { ProdutoModalidadeListComponent } from "./components/admin/produto-modalidade-list/produto-modalidade-list.component";
import { ProjetoFonteRecursoEditComponent } from "./components/admin/projeto-fonte-recurso-edit/projeto-fonte-recurso-edit.component";
import { ProjetoFonteRecursoListComponent } from "./components/admin/projeto-fonte-recurso-list/projeto-fonte-recurso-list.component";
import { ProjetoMoedaEditComponent } from "./components/admin/projeto-moeda-edit/projeto-moeda-edit.component";
import { ProjetoMoedaListComponent } from "./components/admin/projeto-moeda-list/projeto-moeda-list.component";
import { ProjetoSituacaoEditComponent } from "./components/admin/projeto-situacao-edit/projeto-situacao-edit.component";
import { ProjetoSituacaoListComponent } from "./components/admin/projeto-situacao-list/projeto-situacao-list.component";
import { AbasEditComponent } from "./components/processos/abas-edit/abas-edit.component";
import { AbasListComponent } from "./components/processos/abas-list/abas-list.component";
import { GrupoEditComponent } from "./components/processos/grupo-edit/grupo-edit.component";
import { GrupoListComponent } from "./components/processos/grupo-list/grupo-list.component";
import { ProcessoEditComponent } from "./components/processos/processo-edit/processo-edit.component";
import { ProcessoLayoutComponent } from "./components/processos/processo-layout/processo-layout.component";
import { ProcessoListComponent } from "./components/processos/processo-list/processo-list.component";
import { ProcessoQuestoesListComponent } from "./components/processos/processo-questoes-list/processo-questoes-list.component";
import { EquipeCapacidadeExecucaoEditComponent } from "./components/projetos/equipe-capacidade-execucao-edit/equipe-capacidade-execucao-edit.component";
import { EquipeCapacidadeExecucaoListComponent } from "./components/projetos/equipe-capacidade-execucao-list/equipe-capacidade-execucao-list.component";
import { ProjetoDocumentosEditComponent } from "./components/projetos/projeto-documentos-edit/projeto-documentos-edit.component";
import { ProjetoDocumentosListComponent } from "./components/projetos/projeto-documentos-list/projeto-documentos-list.component";
import { ProjetoEditComponent } from "./components/projetos/projeto-edit/projeto-edit.component";
import { ProjetoLayoutComponent } from "./components/projetos/projeto-layout/projeto-layout.component";
import { ProjetoListComponent } from "./components/projetos/projeto-list/projeto-list.component";
import { ProjetoProdutoEditComponent } from "./components/projetos/projeto-produto-edit/projeto-produto-edit.component";
import { ProjetoProdutoListComponent } from "./components/projetos/projeto-produto-list/projeto-produto-list.component";
import { DocumentoTipoResolver } from "./resolver/documento-tipo.resolver";
import { EquipeResponsabilidadeResolver } from "./resolver/equipe-responsabilidade.resolver";
import { GrupoInfoProcessoResolver } from "./resolver/grupo-info-processo.resolver";
import { LinkEvidenciaResolver } from "./resolver/link-evidencia.resolver";
import { LinkLegislacaoResolver } from "./resolver/link-legislacao.resolver";
import { listAtributosProcessoQuestaoResolve } from "./resolver/list-atributos-processo-questao.resolver";
import { PreProjetoExportarResolver } from "./resolver/pre-projeto-exportar.resolver";
import { ProcessoAbasResolver, ProcessoAbasTiposResolver } from "./resolver/processo-abas.resolver";
import { ProcessoCadastroFiltersResolver, ProcessoCadastroResolver } from "./resolver/processo-cadastro.resolver";
import { ProcessoGrupoResolver } from "./resolver/processo-grupo.resolver";
import { ProcessoQuestaoResolver } from "./resolver/processo-questao.resolver";
import { ProcessoStatusResolver } from "./resolver/processo-status.resolver";
import { ProdutoDocumentoResolver } from "./resolver/produto-documento.resolver";
import { ProdutoEtapaModalidadeListResolver, ProdutoEtapaModalidadeResolver } from "./resolver/produto-etapa-modalidade.resolver";
import { ProdutoModalidadeResolver } from "./resolver/produto-modalidade.resolver";
import { ProjetoCadastroAbasResolver, ProjetoCadastroCombosResolver, ProjetoCadastroFiltersResolver, ProjetoCadastroMenuResolver, ProjetoCadastroResolver } from "./resolver/projeto-cadastro.resolver";
import { ProjetoDocumentoFiltersResolver, ProjetoDocumentoResolver } from "./resolver/projeto-documento.resolver";
import { ProjetoEquipeResolver, ProjetoEquipeResponsabilidadesResolver } from "./resolver/projeto-equipe.resolver";
import { ProjetoFonteRecursoResolver } from "./resolver/projeto-fonte-recurso.resolver";
import { ProjetoMoedaResolver } from "./resolver/projeto-moeda.resolver";
import { ProjetoProdutoFiltersResolver, ProjetoProdutoResolver } from "./resolver/projeto-produto.resolver";
import { ProjetoSituacaoResolver } from "./resolver/projeto-situacao.resolver";
import { ProjetoLegislacaoListComponent } from "./components/projetos/projeto-legislacao-list/projeto-legislacao-list.component";
import { ProjetoAbasEditComponent } from "./components/projetos/projeto-abas-edit/projeto-abas-edit.component";
import { ProjetoTramitacaoEditComponent } from "./components/projetos/projeto-tramitacao-edit/projeto-tramitacao-edit.component";
import { ProjetoTramitacaoResolver } from "./resolver/projeto-tramitacao.resolver";
import { CustoEditComponent } from "./components/projetos/custo-edit/custo-edit.component";
import { ImpactoOrcamentarioEditComponent } from "./components/projetos/impacto-orcamentario-edit/impacto-orcamentario-edit.component";
import { ProjetoImpactoOrcamentarioResolver } from "./resolver/projeto-impacto-orcamentario.resolver";
import { ProjetoRelatorioComponent } from "./components/projetos/projeto-relatorio/projeto-relatorio.component";

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'admin',
        children: [
          {
            path: 'link-evidencia',
            children: [
              {
                path: '',
                component: LinkEvidenciaListComponent,
              },
              {
                path: 'adicionar',
                component: LinkEvidenciaEditComponent,
              },
              {
                path: ':id',
                component: LinkEvidenciaEditComponent,
                resolve: { entity: LinkEvidenciaResolver }
              },
            ]
          },
          {
            path: 'link-legislacao',
            children: [
              {
                path: '',
                component: LinkLegislacaoListComponent,
              },
              {
                path: 'adicionar',
                component: LinkLegislacaoEditComponent,
              },
              {
                path: ':id',
                component: LinkLegislacaoEditComponent,
                resolve: { entity: LinkLegislacaoResolver }
              },
            ]
          },
          {
            path: 'processo-status',
            children: [
              {
                path: '',
                component: ProcessoStatusListComponent,
              },
              {
                path: 'adicionar',
                component: ProcessoStatusEditComponent,
              },
              {
                path: ':id',
                component: ProcessoStatusEditComponent,
                resolve: { entity: ProcessoStatusResolver }
              },
            ]
          },
          {
            path: 'equipe-responsabilidade',
            children: [
              {
                path: '',
                component: EquipeResponsabilidadeListComponent,
              },
              {
                path: 'adicionar',
                component: EquipeResponsabilidadeEditComponent,
              },
              {
                path: ':id',
                component: EquipeResponsabilidadeEditComponent,
                resolve: { entity: EquipeResponsabilidadeResolver }
              },
            ]
          },
          {
            path: 'produto-documento',
            children: [
              {
                path: '',
                component: ProdutoDocumentoListComponent,
              },
              {
                path: 'adicionar',
                component: ProdutoDocumentoEditComponent,
              },
              {
                path: ':id',
                component: ProdutoDocumentoEditComponent,
                resolve: { entity: ProdutoDocumentoResolver }
              },
            ]
          },
          {
            path: 'projeto-situacao',
            children: [
              {
                path: '',
                component: ProjetoSituacaoListComponent,
              },
              {
                path: 'adicionar',
                component: ProjetoSituacaoEditComponent,
              },
              {
                path: ':id',
                component: ProjetoSituacaoEditComponent,
                resolve: { entity: ProjetoSituacaoResolver }
              },
            ]
          },
          {
            path: 'projeto-fonte-recurso',
            children: [
              {
                path: 'adicionar',
                component: ProjetoFonteRecursoEditComponent,
              },
              {
                path: ':id',
                component: ProjetoFonteRecursoEditComponent,
                resolve: { entity: ProjetoFonteRecursoResolver }
              },
              {
                path: '',
                component: ProjetoFonteRecursoListComponent,
              },
            ]
          },
          {
            path: 'projeto-moeda',
            children: [
              {
                path: '',
                component: ProjetoMoedaListComponent,
              },
              {
                path: 'adicionar',
                component: ProjetoMoedaEditComponent,
              },
              {
                path: ':id',
                component: ProjetoMoedaEditComponent,
                resolve: { entity: ProjetoMoedaResolver }
              },
            ]
          },
          {
            path: 'produto-etapa-modalidade',
            children: [
              {
                path: '',
                component: ProdutoEtapaModalidadeListComponent,
              },
              {
                path: 'adicionar',
                component: ProdutoEtapaModalidadeEditComponent,
              },
              {
                path: ':id',
                component: ProdutoEtapaModalidadeEditComponent,
                resolve: { entity: ProdutoEtapaModalidadeResolver }
              },
            ]
          },
          {
            path: 'produto-modalidade',
            children: [
              {
                path: '',
                component: ProdutoModalidadeListComponent,
              },
              {
                path: 'adicionar',
                component: ProdutoModalidadeEditComponent,
              },
              {
                path: ':id',
                component: ProdutoModalidadeEditComponent,
                resolve: { entity: ProdutoModalidadeResolver, etapasList: ProdutoEtapaModalidadeListResolver }
              },
            ]
          },
          {
            path: 'documento-tipo',
            children: [
              {
                path: '',
                component: DocumentoTipoListComponent,
              },
              {
                path: 'adicionar',
                component: DocumentoTipoEditComponent,
              },
              {
                path: ':id',
                component: DocumentoTipoEditComponent,
                resolve: { entity: DocumentoTipoResolver }
              },
            ]
          },
          {
            path: 'exportacsv',
            children: [
              {
                path: '',
                component: ExportarListComponent,
                resolve: { processos: PreProjetoExportarResolver }
              },
            ]
          },
          {
            path: 'processo-questao',
            children: [
              {
                path: 'adicionar',
                component: ProcessoQuestaoEditComponent,
                resolve: { listAtributosProcessoQuestao: listAtributosProcessoQuestaoResolve }
              },
              {
                path: ':id',
                component: ProcessoQuestaoEditComponent,
                resolve: { listAtributosProcessoQuestao: listAtributosProcessoQuestaoResolve, entity: ProcessoQuestaoResolver }
              },
              {
                path: '',
                component: ProcessoQuestaoListComponent,
                //resolve: { processos: PreProjetoExportarResolver }
              },
            ]
          },
        ],
      },
      {
        path: 'projeto',
        children: [
          {
            path: '',
            component: ProjetoListComponent,
            resolve: { filters: ProjetoCadastroFiltersResolver },
          },
          {
            path: 'relatorio',
            component: ProjetoRelatorioComponent,
          },
          {
            path: 'adicionar',
            component: ProjetoEditComponent,
            resolve: { filters: ProjetoCadastroCombosResolver },
          },
          {
            path: ':id',
            component: ProjetoLayoutComponent,
            resolve: { infoProjeto: ProjetoCadastroMenuResolver },
            children: [
              { path: '', redirectTo: 'cadastro', pathMatch: "full" },
              {
                path: 'cadastro',
                component: ProjetoEditComponent,
                resolve: { filters: ProjetoCadastroCombosResolver, entity: ProjetoCadastroResolver },
              },
              {
                path: 'produtos',
                component: ProjetoProdutoListComponent,
              },
              {
                path: 'aba/:tab_id',
                component: ProjetoAbasEditComponent,
                resolve: { entity: ProjetoCadastroAbasResolver },
              },
              {
                path: 'custos',
                children: [
                  {
                    path: '',
                    component: CustoEditComponent,
                    resolve: { filters: ProjetoCadastroCombosResolver }
                  },
                  {
                    path: 'impacto/adicionar',
                    component: ImpactoOrcamentarioEditComponent,
                  }
                ]
              },
              {
                path: 'cronograma',
                component: ProjetoDocumentosListComponent,
                data: { type: true },
              },
              {
                path: 'documentos',
                component: ProjetoDocumentosListComponent,
              },
              {
                path: 'equipe',
                children: [
                  {
                    path: '',
                    component: EquipeCapacidadeExecucaoListComponent,
                  },
                  {
                    path: 'adicionar',
                    component: EquipeCapacidadeExecucaoEditComponent,
                    resolve: { responsabilidadesList: ProjetoEquipeResponsabilidadesResolver }
                  }
                ]
              },
              {
                path: 'legislacao',
                component: ProjetoLegislacaoListComponent,
              },
              {
                path: 'tramitacao',
                component: ProjetoTramitacaoEditComponent,
                resolve: { entity: ProjetoTramitacaoResolver },
              },
            ],
          },
          {
            path: 'produtos',
            children: [
              {
                path: ':id/adicionar',
                component: ProjetoProdutoEditComponent,
                resolve: { filters: ProjetoProdutoFiltersResolver, }
              },
              {
                path: ':id',
                component: ProjetoProdutoEditComponent,
                resolve: { entity: ProjetoProdutoResolver, filters: ProjetoProdutoFiltersResolver, }
              },
            ],
          },
          {
            path: 'equipe/:id',
            component: EquipeCapacidadeExecucaoEditComponent,
            resolve: { responsabilidadesList: ProjetoEquipeResponsabilidadesResolver, entity: ProjetoEquipeResolver }
          },
          {
            path: 'custos/impacto/:id',
            component: ImpactoOrcamentarioEditComponent,
            resolve: { entity: ProjetoImpactoOrcamentarioResolver }
          },
          {
            path: 'documentos',
            children: [
              {
                path: ':id/adicionar',
                component: ProjetoDocumentosEditComponent,
                resolve: { list: ProjetoDocumentoFiltersResolver, }
              },
              {
                path: ':id',
                component: ProjetoDocumentosEditComponent,
                resolve: { list: ProjetoDocumentoFiltersResolver, entity: ProjetoDocumentoResolver, }
              },
            ],
          },
          {
            path: 'cronograma',
            children: [
              {
                path: ':id/adicionar',
                component: ProjetoDocumentosEditComponent,
                resolve: { list: ProjetoDocumentoFiltersResolver, },
                data: { type: true },
              },
              {
                path: ':id',
                component: ProjetoDocumentosEditComponent,
                resolve: { list: ProjetoDocumentoFiltersResolver, entity: ProjetoDocumentoResolver, },
                data: { type: true },
              },
            ],
          }
        ],
      },
      {
        path: 'processos',
        children: [
          {
            path: '',
            component: ProcessoListComponent,
          },
          {
            path: 'adicionar',
            component: ProcessoEditComponent,
            resolve: { filters: ProcessoCadastroFiltersResolver, }
          },
          {
            path: ':id',
            component: ProcessoLayoutComponent,
            children: [
              { path: '', redirectTo: 'cadastro', pathMatch: "full" },
              {
                path: 'cadastro',
                component: ProcessoEditComponent,
                resolve: { entity: ProcessoCadastroResolver, filters: ProcessoCadastroFiltersResolver, }
              },
              {
                path: 'grupos',
                component: GrupoListComponent,
              },
              {
                path: 'questoes',
                component: ProcessoQuestoesListComponent,
              },
              {
                path: 'abas',
                children: [
                  {
                    path: '',
                    component: AbasListComponent,
                  },
                  {
                    path: 'adicionar',
                    component: AbasEditComponent,
                    resolve: { tiposList: ProcessoAbasTiposResolver }
                  }
                ]
              },
            ]
          },
          {
            path: 'grupos',
            children: [
              {
                path: ':id/adicionar',
                component: GrupoEditComponent,
                resolve: { infoProcesso: GrupoInfoProcessoResolver }
              },
              {
                path: ':id',
                component: GrupoEditComponent,
                resolve: { entity: ProcessoGrupoResolver }
              }
            ]
          },
          {
            path: 'abas/:id',
            component: AbasEditComponent,
            resolve: { entity: ProcessoAbasResolver, tiposList: ProcessoAbasTiposResolver }
          }
        ]
      },
    ]
  }
]

export const PreProjetoRoutes = RouterModule.forChild(routes);